// extracted by mini-css-extract-plugin
export default {"supportPage":"Support_supportPage__MI2XO","heading":"Support_heading__+qZAR"};